export interface Category {
  id: string;
  name: string;
  icon: string;
  priority: number;
  _rawNameMap?: Record<string, string>;
}

export const getLocalizedName = (
  category: Category,
  lang: string
): string => {
  const localizedName = category._rawNameMap?.[lang] || category.name;
  return String(localizedName || '');
};
